export interface ParsedFeature {
  text: string
  isFeature: boolean
  icon: string | null
  colorClass: string | null
  children?: ParsedFeature[]
}

export const parseFeatureLine = (line: string): ParsedFeature => {
  const trimmedLine = line.trim()

  const base: ParsedFeature = {
    text: trimmedLine,
    isFeature: false,
    icon: null,
    colorClass: null
  }

  if (trimmedLine.startsWith('[+]')) {
    return {
      ...base,
      text: trimmedLine.substring(3).trim(),
      isFeature: true,
      icon: 'ti-check',
      colorClass: 'text-success'
    }
  }

  if (trimmedLine.startsWith('[-]')) {
    return {
      ...base,
      text: trimmedLine.substring(3).trim(),
      isFeature: true,
      icon: 'ti-x',
      colorClass: 'text-danger'
    }
  }

  return base
}
